import { useParams } from "react-router-dom";

import { useGetShipmentBasic } from "api/queries/shipments/useGetShipmentBasic";
import { useGetShipmentDetails } from "api/queries/shipments/useGetShipmentDetails";
import { getTimezoneOffset } from "helpers/dateTimeHelper";
import ProofOfDeliveryLocation from "./ProofOfDeliveryLocation";
import ProofOfDeliverySharedFields from "./ProofOfDeliverySharedFields";

const ProofOfDelivery = function () {
  const { id: shipmentId } = useParams();

  const { data: shipmentDetails = {} } = useGetShipmentDetails(shipmentId!, true, {
    enabled: !!shipmentId,
    refetchOnMount: false,
  });

  const { data: shipmentData }: any = useGetShipmentBasic(shipmentId!, {
    enabled: !!shipmentId,
    refetchOnMount: false,
  });
  const allowProviderToSkipInvoiceSubmission =
    shipmentData?.organization?.allow_provider_to_skip_invoice_submission ?? false;
  const quotedDeliveryDate = shipmentData?.schedule?.stop1_quoted_delivery_date;
  const quotedDeliveryTime = shipmentData?.schedule?.stop1_quoted_delivery_time;
  const isOffPlatform = shipmentData?.shipment?.is_off_platform_shipment || false;
  const timezoneOffset = getTimezoneOffset(shipmentDetails?.schedule?.stop1_timezone);
  const locationLabel =
    shipmentDetails?.schedule?.stop1_city || shipmentDetails?.schedule?.stop1_country || "";

  return (
    <div className="pod-container">
      <ProofOfDeliveryLocation
        isOffPlatform={isOffPlatform}
        locationLabel={locationLabel}
        timezoneOffset={timezoneOffset}
        country={shipmentDetails?.schedule?.stop1_country}
      />
      <ProofOfDeliverySharedFields
        quotedDeliveryDate={quotedDeliveryDate}
        quotedDeliveryTime={quotedDeliveryTime}
        timezoneOffset={timezoneOffset}
        showBillingStatus={allowProviderToSkipInvoiceSubmission}
      />
    </div>
  );
};

export default ProofOfDelivery;
